export default {
  'employee.payment.requiresApproval': 'Payment has been submitted for approval',
  'employee.payment.employeePayment': 'Employee Payment',
  'employee.payment.alert': 'You are about to <%=action%> an',
  'employee.payment.alert.approve': 'You are about to <%=action%> a(n)',
  'employees.payment.employees': 'employees',
  'employees.payment.for': 'for',
  'employees.payment.fromAccount': 'from account',
  'employee.date.past.error': 'Payment date must be after <%=earliestDayForAch%>.',
  'employee.payment.customerTraceNumber': 'Customer trace number',
  'employee.payment.smallBusiness': 'smallBusiness',
  'employee.payment.noCompany': 'No ACH Company found.',
  'employee.payment.title.initiate': 'Initiate Employee Payment',
  'employee.payment.title.modify': 'Modify Employee Payment',
  'employee.payment.title.view': 'View Employee Payment',
  'employee.payment.column.lastAmount': 'Last Amount',
  'employee.payment.column.thisAmount': 'This Amount',
  'employee.payment.column.id': 'Id'
};
